import {
  FETCH_HOLIDAYS_REQUEST, FETCH_HOLIDAYS_SUCCESS, FETCH_HOLIDAYS_FAIL,
} from "../../constants/Leave/HolidayConstants";
import HolidayService from "../../service/Leave/HolidayService";
import { extractRows, toDateKey, assertOk } from "../../service/Leave/leaveHelpers";

const errMsg = (error, fallback) => error.response?.data?.Result || error.response?.data?.message || error.message || fallback;

// DGES also accepts compact dates like 20261225
const dateKey = (v) => {
  const s = String(v ?? "").trim();
  if (/^\d{8}$/.test(s)) return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
  return toDateKey(s);
};

const isActive = (v) => v === true || v === 1 || ["TRUE", "1", "Y", "YES"].includes(String(v ?? "").trim().toUpperCase());

export const fetchHolidays = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_HOLIDAYS_REQUEST });
    const body = assertOk(await HolidayService.getAll());
    const data = extractRows(body)
      .filter(Boolean)
      .map((h) => ({
        id: String(h.HAH_HOLIDAY_ID ?? "").trim(),
        date: dateKey(h.HAH_HOLIDAY_DATE ?? h.HAH_DATE),
        name: String(h.HAH_HOLIDAY_NAME ?? "").trim(),
        type: String(h.HAH_HOLIDAY_TYPE ?? "").trim(),
        active: isActive(h.HAH_IS_ACTIVE),
        remarks: String(h.HAH_REMARKS ?? "").trim(),
      }))
      .filter((h) => /^\d{4}-\d{2}-\d{2}$/.test(h.date));
    dispatch({ type: FETCH_HOLIDAYS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_HOLIDAYS_FAIL, payload: errMsg(error, "Failed to fetch holidays") });
  }
};

const checkSaved = (body) => {
  const code = body?.statusCode ?? body?.StatusCode;
  if (code !== undefined && code !== 200 && code !== 201) {
    const msg = String(body?.Result || body?.Message || `Server error (status ${code})`);
    throw new Error(msg.split("\n")[0].trim());
  }
  return body;
};

const run = (call, fallback) => async (dispatch) => {
  try {
    checkSaved(await call());
    await dispatch(fetchHolidays());
    return { ok: true };
  } catch (error) {
    return { ok: false, message: errMsg(error, fallback) };
  }
};

export const addHoliday = (h) => run(() => HolidayService.add(h), "Failed to add holiday");
export const updateHoliday = (h) => run(() => HolidayService.update(h), "Failed to update holiday");
export const deleteHoliday = (id) => run(() => HolidayService.remove(id), "Failed to delete holiday");